import { Product } from '../types/product'

export const products: Product[] = [
  {
    id: '1',
    title: 'Cepillo Eléctrico Makita M1902B',
    description:
      'Cepillo eléctrico profesional Makita de 82mm (3-1/4"). Ideal para trabajos de carpintería y acabados en madera. Incluye guía paralela y accesorios.',
    price: 89.99,
    imageUrl:
      'https://cdn.magicpatterns.com/uploads/trfGvNqRRChhJRXCgRSDRq/619213296_18152543959429829_3111055205579381385_n.webp',
    category: 'Herramientas Eléctricas',
    brand: 'Makita',
    rating: 4.9,
    reviews: 128,
    sku: 'MAK-M1902B',
    material: 'Aluminio y plástico reforzado',
    dimensions: '82mm ancho de corte',
    weight: '2.5 kg',
    specifications: [
      '580W de potencia',
      '16000 RPM',
      'Profundidad de corte 1mm',
      'Cable de 2m',
    ],
    inStock: true,
    isHot: true,
  },
  {
    id: '2',
    title: 'Manillón para Puerta MD 2004 Acero Inoxidable',
    description:
      'Manillón elegante para puerta de madera o cristal. Acabado en acero inoxidable pulido. Diseño moderno y resistente para uso residencial y comercial.',
    price: 45.99,
    imageUrl:
      'https://cdn.magicpatterns.com/uploads/uYKJ2NhNHRFP4rcW5H9pJz/625987125_18154127188429829_2563455859483111642_n.webp',
    category: 'Cerrajería',
    brand: 'ZOE',
    rating: 4.8,
    reviews: 89,
    sku: 'MD-2004',
    material: 'Acero Inoxidable 304',
    dimensions: '45cm x 25mm',
    weight: '800g',
    specifications: [
      'Para puertas de madera y cristal',
      'Incluye tornillería',
      'Acabado satinado',
      'Fácil instalación',
    ],
    inStock: true,
    isHot: true,
  },
  {
    id: '3',
    title: 'Manilla Fija/Móvil Atenas ZCE-9588AJ',
    description:
      'Manilla de acero inoxidable #304 modelo Atenas. Fija/Móvil para puerta principal con roceta cuadrada. Incluye tornillos y llave "L".',
    price: 67.5,
    imageUrl:
      'https://cdn.magicpatterns.com/uploads/ayAsRZ1NAqbUQ1Uz8bU4r3/623201784_18153290383429829_1914485443680118931_n.webp',
    category: 'Cerrajería',
    brand: 'ZOE',
    rating: 4.9,
    reviews: 156,
    sku: 'ZCE-9588AJ',
    material: 'Acero Inoxidable #304',
    dimensions: 'Estándar para puerta',
    weight: '650g',
    specifications: [
      'Apertura izquierda/derecha',
      'Roceta cuadrada',
      'Acabado pulido',
      'Incluye herrajes',
    ],
    inStock: true,
    isHot: true,
  },
  {
    id: '4',
    title: 'Taladro Percutor DeWalt DWD024',
    description:
      'Taladro percutor de 700W con velocidad variable. Ideal para perforar concreto, madera y metal. Mandril de 13mm.',
    price: 125.0,
    imageUrl:
      'https://images.unsplash.com/photo-1504148455328-c376907d081c?auto=format&fit=crop&q=80&w=800',
    category: 'Herramientas Eléctricas',
    brand: 'DeWalt',
    rating: 4.7,
    reviews: 234,
    sku: 'DWD-024',
    material: 'Metal y plástico',
    dimensions: '30cm x 8cm',
    weight: '1.8 kg',
    specifications: [
      '700W',
      '0-2800 RPM',
      'Mandril 13mm',
      'Empuñadura auxiliar',
    ],
    inStock: true,
  },
  {
    id: '5',
    title: 'Juego de Llaves Combinadas Stanley 12 Piezas',
    description:
      'Set profesional de llaves combinadas en acero cromo vanadio. Medidas de 8mm a 19mm. Acabado cromado resistente a la corrosión.',
    price: 35.99,
    imageUrl:
      'https://images.unsplash.com/photo-1581147036324-c17ac41f3e6a?auto=format&fit=crop&q=80&w=800',
    category: 'Herramientas Eléctricas',
    brand: 'Stanley',
    rating: 4.6,
    reviews: 312,
    sku: 'STN-LLC12',
    material: 'Acero Cromo Vanadio',
    dimensions: '8mm - 19mm',
    weight: '1.2 kg',
    specifications: [
      '12 piezas',
      'Acabado cromado',
      'Estuche incluido',
      'Garantía de por vida',
    ],
    inStock: true,
  },
  {
    id: '6',
    title: 'Cerradura de Seguridad Multipunto',
    description:
      'Cerradura de alta seguridad con sistema multipunto. 3 puntos de cierre para máxima protección. Cilindro antibumping incluido.',
    price: 189.0,
    imageUrl:
      'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?auto=format&fit=crop&q=80&w=800',
    category: 'Cerrajería',
    brand: 'ZOE',
    rating: 4.9,
    reviews: 78,
    sku: 'ZOE-MP300',
    material: 'Acero templado',
    dimensions: 'Estándar europeo',
    weight: '2.1 kg',
    specifications: [
      '3 puntos de cierre',
      'Antibumping',
      'Antipalanca',
      '5 llaves incluidas',
    ],
    inStock: true,
  },
  {
    id: '7',
    title: 'Esmeriladora Angular Bosch GWS 850',
    description:
      'Esmeriladora angular de 850W con disco de 4-1/2". Compacta y potente para corte y desbaste de metales.',
    price: 79.99,
    imageUrl:
      'https://images.unsplash.com/photo-1572981779307-38b8cabb2407?auto=format&fit=crop&q=80&w=800',
    category: 'Herramientas Eléctricas',
    brand: 'Bosch',
    rating: 4.8,
    reviews: 445,
    sku: 'BOS-GWS850',
    material: 'Metal y plástico',
    dimensions: '4-1/2" (115mm)',
    weight: '1.8 kg',
    specifications: [
      '850W',
      '11000 RPM',
      'Interruptor deslizante',
      'Protector ajustable',
    ],
    inStock: true,
    isHot: true,
  },
  {
    id: '8',
    title: 'Kit de Pintura Profesional 15 Piezas',
    description:
      'Set completo para pintura que incluye rodillos, brochas, bandejas y accesorios. Ideal para proyectos de renovación.',
    price: 42.5,
    imageUrl:
      'https://images.unsplash.com/photo-1562259949-e8e7689d7828?auto=format&fit=crop&q=80&w=800',
    category: 'Pintura',
    brand: 'Truper',
    rating: 4.5,
    reviews: 167,
    sku: 'TRP-KIT15',
    material: 'Diversos',
    dimensions: 'Varios tamaños',
    weight: '1.5 kg',
    specifications: [
      '3 rodillos',
      '5 brochas',
      '2 bandejas',
      'Extensión telescópica',
    ],
    inStock: true,
  },
  {
    id: '9',
    title: 'Nivel Láser Autonivelante',
    description:
      'Nivel láser de línea cruzada con autonivelación. Alcance de 15 metros. Incluye soporte magnético y estuche.',
    price: 156.0,
    imageUrl:
      'https://images.unsplash.com/photo-1504917595217-d4dc5ebe6122?auto=format&fit=crop&q=80&w=800',
    category: 'Construcción',
    brand: 'Bosch',
    rating: 4.7,
    reviews: 89,
    sku: 'BOS-GLL2',
    material: 'Plástico ABS',
    dimensions: '10cm x 10cm x 5cm',
    weight: '500g',
    specifications: [
      'Alcance 15m',
      'Precisión ±0.3mm/m',
      'Autonivelante',
      'Línea horizontal y vertical',
    ],
    inStock: true,
  },
  {
    id: '10',
    title: 'Caja de Herramientas Metálica 5 Bandejas',
    description:
      'Caja de herramientas profesional en acero con 5 bandejas desplegables. Cerradura de seguridad y asa ergonómica.',
    price: 85.0,
    imageUrl:
      'https://images.unsplash.com/photo-1530124566582-a618bc2615dc?auto=format&fit=crop&q=80&w=800',
    category: 'Herramientas Eléctricas',
    brand: 'Stanley',
    rating: 4.8,
    reviews: 203,
    sku: 'STN-BOX5',
    material: 'Acero calibre 22',
    dimensions: '53cm x 23cm x 20cm',
    weight: '4.5 kg',
    specifications: [
      '5 bandejas',
      'Cerradura incluida',
      'Capacidad 15kg',
      'Acabado anticorrosivo',
    ],
    inStock: true,
  },
  {
    id: '11',
    title: 'Llave Ajustable Truper 12"',
    description:
      'Llave ajustable de 12 pulgadas con apertura máxima de 35mm. Mandíbulas fresadas para mejor agarre.',
    price: 18.99,
    imageUrl:
      'https://images.unsplash.com/photo-1426927308491-6380b6a9936f?auto=format&fit=crop&q=80&w=800',
    category: 'Herramientas Eléctricas',
    brand: 'Truper',
    rating: 4.4,
    reviews: 567,
    sku: 'TRP-LA12',
    material: 'Acero al carbono',
    dimensions: '12" (300mm)',
    weight: '450g',
    specifications: [
      'Apertura 35mm',
      'Mango antideslizante',
      'Escala métrica',
      'Tratamiento térmico',
    ],
    inStock: true,
  },
  {
    id: '12',
    title: 'Bomba de Agua Periférica 1/2 HP',
    description:
      'Bomba periférica para uso doméstico e industrial ligero. Ideal para sistemas de presión y riego.',
    price: 95.0,
    imageUrl:
      'https://images.unsplash.com/photo-1585771724684-38269d6639fd?auto=format&fit=crop&q=80&w=800',
    category: 'Plomería',
    brand: 'Truper',
    rating: 4.6,
    reviews: 134,
    sku: 'TRP-BOMB05',
    material: 'Hierro fundido y acero',
    dimensions: '25cm x 15cm x 20cm',
    weight: '5.5 kg',
    specifications: [
      '1/2 HP',
      'Altura máx. 35m',
      'Caudal 40 L/min',
      '110V/60Hz',
    ],
    inStock: true,
  },
]
